/**
 * Landing pre-filter: keep only allowed paths for simple landing runs.
 * Used before UI display and before PatchGuard.
 */

function normalizePath(p: string): string {
  return String(p ?? "").trim().replace(/\\/g, "/").replace(/^\.\//, "").replace(/^\/+/, "");
}

function isAllowedLandingPath(norm: string): boolean {
  return (
    norm === "src/App.tsx" ||
    norm === "src/pages/LandingPage.tsx" ||
    norm.startsWith("src/components/ui/")
  );
}

export type PatchInput = { filePath?: string; path?: string; [k: string]: unknown };

export function filterEditsForLanding(
  edits: PatchInput[]
): { filteredEdits: PatchInput[]; droppedEdits: Array<{ path: string; norm: string }> } {
  const filteredEdits: PatchInput[] = [];
  const droppedEdits: Array<{ path: string; norm: string }> = [];
  for (const e of edits) {
    const raw = e?.filePath ?? e?.path;
    if (raw == null) continue;
    const norm = normalizePath(raw);
    if (!norm || norm.includes("..")) continue;
    if (isAllowedLandingPath(norm)) {
      filteredEdits.push(e);
    } else {
      droppedEdits.push({ path: raw, norm });
    }
  }
  return { filteredEdits, droppedEdits };
}
